
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { openEmailClient } from '../../services/emailService';

export default function Contato() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    assunto: '',
    veiculo: '',
    ano: '',
    mensagem: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    try {
      // Validar campos obrigatórios
      if (!formData.nome || !formData.email || !formData.assunto || !formData.mensagem) {
        setSubmitStatus('error');
        setIsSubmitting(false);
        return;
      }

      // Abrir cliente de email
      const success = openEmailClient(formData);

      if (success) {
        setSubmitStatus('success');
        // Limpar formulário após 2 segundos
        setTimeout(() => {
          setFormData({
            nome: '',
            email: '',
            telefone: '',
            assunto: '',
            veiculo: '',
            ano: '',
            mensagem: ''
          });
          setSubmitStatus('');
        }, 2000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const contactInfo = [
    // {
    //   title: 'Telefone',
    //   value: '(11) 3333-4444',
    //   icon: 'ri-phone-line',
    //   description: 'Seg a Sex, 8h às 18h'
    // },
    {
      title: 'WhatsApp',
      value: '(11) 99154-2774',
      icon: 'ri-whatsapp-line',
      description: 'Atendimento rápido'
    },
    {
      title: 'Email',
      value: 'comercial@globalzeit.com.br',
      icon: 'ri-mail-line',
      description: 'Resposta em até 24h'
    }
  ];

  const businessHours = [
    { day: 'Segunda a Sexta', hours: '8:00 - 18:00' },
    { day: 'Sábado', hours: '8:00 - 12:00' },
    { day: 'Domingo', hours: 'Fechado' }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-teal-600 to-teal-700 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Entre em Contato
            </h1>
            <p className="text-xl text-teal-100 max-w-3xl mx-auto">
              Nossa equipe especializada está pronta para ajudar você a encontrar as peças certas para seu carro.
            </p>
          </div>
        </div>
      </section>

      {/* Contato Principal */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Formulário */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Envie sua Mensagem</h2>
              <p className="text-gray-600 mb-8">
                Preencha o formulário abaixo e nossa equipe entrará em contato em breve.
              </p>

              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="nome" className="block text-sm font-medium text-gray-700 mb-2">
                      Nome Completo *
                    </label>
                    <input
                      type="text"
                      id="nome"
                      name="nome"
                      required
                      value={formData.nome}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 text-sm"
                      placeholder="Seu nome completo"
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                      Email *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      value={formData.email}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 text-sm"
                      placeholder="seu@email.com"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="telefone" className="block text-sm font-medium text-gray-700 mb-2">
                      Telefone/WhatsApp
                    </label>
                    <input
                      type="tel"
                      id="telefone"
                      name="telefone"
                      value={formData.telefone}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus-border-teal-500 text-sm"
                      placeholder="(11) 99154-2774"
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="assunto" className="block text-sm font-medium text-gray-700 mb-2">
                      Assunto *
                    </label>
                    <select
                      id="assunto"
                      name="assunto"
                      required
                      value={formData.assunto}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus-border-teal-500 text-sm pr-8 cursor-pointer"
                    >
                      <option value="">Selecione o assunto</option>
                      <option value="orcamento">Solicitar Orçamento</option>
                      <option value="importacao">Importação de peças e acessórios</option>
                      <option value="suporte">Suporte Técnico</option>
                      <option value="garantia">Questões de Garantia</option>
                      <option value="outros">Outros</option>
                    </select>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="veiculo" className="block text-sm font-medium text-gray-700 mb-2">
                      Veículo
                    </label>
                    <input
                      type="text"
                      id="veiculo"
                      name="veiculo"
                      value={formData.veiculo}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus-border-teal-500 text-sm"
                      placeholder="Ex: Volkswagen Fusca"
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="ano" className="block text-sm font-medium text-gray-700 mb-2">
                      Ano
                    </label>
                    <input
                      type="text"
                      id="ano"
                      name="ano"
                      value={formData.ano}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus-border-teal-500 text-sm"
                      placeholder="Ex: 1975"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="mensagem" className="block text-sm font-medium text-gray-700 mb-2">
                    Mensagem *
                  </label>
                  <textarea
                    id="mensagem"
                    name="mensagem"
                    required
                    rows={6}
                    maxLength={500}
                    value={formData.mensagem}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus-border-teal-500 text-sm resize-none"
                    placeholder="Descreva sua necessidade, peça específica ou dúvida..."
                  ></textarea>
                  <div className="text-right text-xs text-gray-500 mt-1">
                    {formData.mensagem.length}/500 caracteres
                  </div>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting || formData.mensagem.length > 500}
                  className="w-full bg-teal-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-teal-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                >
                  {isSubmitting ? 'Enviando...' : 'Enviar Mensagem'}
                </button>

                {submitStatus === 'success' && (
                  <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                    <div className="flex items-center gap-2">
                      <i className="ri-check-circle-line text-green-600"></i>
                      <span className="text-green-800 font-medium">Formulário pronto para envio!</span>
                    </div>
                    <p className="text-green-700 text-sm mt-1">
                      Seu cliente de email foi aberto. Complete o envio clicando em "Enviar".
                    </p>
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                    <div className="flex items-center gap-2">
                      <i className="ri-error-warning-line text-red-600"></i>
                      <span className="text-red-800 font-medium">Erro ao abrir cliente de email</span>
                    </div>
                    <p className="text-red-700 text-sm mt-1">
                      Envie um email diretamente para: comercial@globalzeit.com.br
                    </p>
                  </div>
                )}
              </form>
            </div>

            {/* Informações de Contato */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Informações de Contato</h2>
              
              <div className="space-y-6 mb-8">
                {contactInfo.map((info, index) => (
                  <div key={index} className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className={`${info.icon} text-xl text-teal-600`}></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900">{info.title}</h3>
                      <p className="text-gray-900 font-medium">{info.value}</p>
                      <p className="text-gray-600 text-sm">{info.description}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Horário de Funcionamento */}
              <div className="bg-gray-50 rounded-lg p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                  <i className="ri-time-line text-teal-600"></i>
                  Horário de Funcionamento
                </h3>
                <div className="space-y-2">
                  {businessHours.map((schedule, index) => (
                    <div key={index} className="flex justify-between">
                      <span className="text-gray-600">{schedule.day}</span>
                      <span className="font-medium text-gray-900">{schedule.hours}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Atendimento Online */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Atendimento Online</h2>
            <p className="text-lg text-gray-600">Loja 100% virtual com atendimento especializado</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* <div className="bg-white rounded-lg shadow-sm p-8 text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-phone-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Atendimento por Telefone</h3>
              <p className="text-gray-600 mb-4">Fale diretamente com nossos especialistas</p>
              <p className="text-teal-600 font-semibold">(11) 3333-4444</p>
            </div> */}
            
            <div className="bg-white rounded-lg shadow-sm p-8 text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-whatsapp-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">WhatsApp Business</h3>
              <p className="text-gray-600 mb-4">Atendimento rápido e personalizado</p>
              <p className="text-teal-600 font-semibold">(11) 99154-2774</p>
            </div>
            
            <div className="bg-white rounded-lg shadow-sm p-8 text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-mail-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Email Especializado</h3>
              <p className="text-gray-600 mb-4">Suporte técnico detalhado</p>
              <p className="text-teal-600 font-semibold">comercial@globalzeit.com.br</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Rápido */}
      {/* <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Perguntas Frequentes</h2>
            <p className="text-lg text-gray-600">Respostas rápidas para dúvidas comuns</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white border border-gray-200 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                Qual o prazo de entrega?
              </h3>
              <p className="text-gray-600">
                Peças em estoque: 3-7 dias úteis. Importações: 30-60 dias dependendo do tipo de frete escolhido.
              </p>
            </div>
            
            <div className="bg-white border border-gray-200 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                Vocês têm garantia?
              </h3>
              <p className="text-gray-600">
                Sim! Peças nacionais têm 90 dias de garantia e importadas 60 dias contra defeitos de fabricação.
              </p>
            </div>
            
            <div className="bg-white border border-gray-200 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                Fazem instalação?
              </h3>
              <p className="text-gray-600">
                Oferecemos suporte técnico e indicamos oficinas parceiras especializadas em carros.
              </p>
            </div>
            
            <div className="bg-white border border-gray-200 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                Como funciona a compra online?
              </h3>
              <p className="text-gray-600">
                Você escolhe as peças, fazemos o orçamento e enviamos para todo o Brasil via transportadora.
              </p>
            </div>
          </div>
          
          <div className="text-center mt-8">
            <a
              href="/suporte"
              className="text-teal-600 hover:text-teal-700 font-medium cursor-pointer"
            >
              Ver todas as perguntas frequentes →
            </a>
          </div>
        </div>
      </section> */}

      <Footer />
    </div>
  );
}
